// Usage Example --------------

//<lag-tooltip>
//    Content to always show

//    <span slot="tooltip">
//          Content to show on hover <img src='' />
//    </span>

//</lag-tooltip>

// Example with image ------------------------

//<lag-tooltip>
//    <span>
//        <iron-image id="imgThumb[[item.inventoryID]]" sizing="contain"
//            class="thumbnailImage" data-id$="[[item.inventoryID]]" on-tap="_handleOpenGalary" alt="[[localize('consignedInventory.imageAlt')]]"
//            src="[[item.firstImageUrl_S]]" />
//    </span>
//    <span slot="tooltip">
//        <img sizing="contain" class="largeThumbnailImage" src="[[item.firstImageUrl]]" />
//    </span>
//</lag-tooltip>

//--------------------------------------------


import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import { Localizer } from '../extendibles/Localizer.js';
import { defineElement } from '../../utility/defineElement.js';
import { template } from './lag-tooltip.html.js';

defineElement(class extends Localizer(PolymerElement) {
    static get is() { return 'lag-tooltip'; }
    static get template() { return template }
});